import { pdfjs } from "react-pdf";
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs";

// pdf.js runs its parser in a web worker. That worker used to be pulled from unpkg.com, so
// every PDF in the app depended on a third-party CDN - and, once a Content Security Policy
// was in place, on `script-src` trusting that CDN. It does not, so pdf.js fell back to a blob
// worker (also blocked) and then to importing the module (blocked too), which surfaced as
// "Failed to load PDF file".
//
// The import above is turned into an emitted asset by the `asset/resource` rule in
// config/webpack/commonWebpackConfig.js, so the worker is served from our own origin under
// /packs and needs no CSP exception. `pdfjs-dist` is a direct dependency pinned to the version
// react-pdf resolves, so the two cannot drift apart.
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

export default pdfjs;
